module.exports = __webpack_public_path__ + "img/prd.186379d0.png";